(function () {
    'use strict';
    angular.module("EventListApp").controller('EventListCtrl', ['Constants', 'ApiFactory',
        function (Constants, ApiFactory) {
            const vm = this;
            vm.pageUrl = PageUrl;
            vm.letterLimit = 100;
            vm.limit = 150;
            vm.loadingResult = false;
            vm.currentType = 0;
            vm.hasResult = false;
            vm.searchText = "";
            vm.wordLimit = 15;
            vm.events = [];
            vm.display = { ProfDesc: "", Date: "" }
            const prevEvents = {};
            let currentYear = new Date().getFullYear();

            const searchParams = {
                CompanyId: 0,
                PageIndex: 1,
                PageSize: 20,
                SearchText: "",
                SubjectId: 0,
                FromDate: null,
                ProfDesc: "",
                Lang: 13,
                SearchType: 0
            }

            vm.initList = function (cmpID, cmpLang, cmpYear) {
                searchParams.CompanyId = cmpID;
                searchParams.Lang = cmpLang;
                vm.SearchModel = angular.copy(searchParams);
                vm.minYear = cmpYear;
                getInitialEvents();
            }

            vm.loadMore = function () {
                if (!vm.hasResult)
                    return;
                getEvents(vm.currentType);
            };

            vm.getEventByText = function (text) {
                vm.events = [];
                vm.SearchModel.PageIndex = 1;
                vm.currentType = Constants.SearchTypes.ByParameters;
                vm.SearchModel.SearchText = text;
                getEvents(vm.currentType);
            };

            function getInitialEvents() {
                if (vm.currentType == 0)
                    vm.currentType = Constants.SearchTypes.All;

                getEvents(function () {
                    if (currentYear > vm.minYear) {
                        vm.currYear = getPrevYear(vm.minYear);
                        vm.getPrevEvents();
                    }
                });
            }

            vm.getPrevEvents = function () {
                // to prevent object keys reorder
                const key = vm.currYear ? ' ' + vm.currYear : '';
                if (vm.currYear && prevEvents.hasOwnProperty(key)
                    && prevEvents[key].loadingResult) // if loading year results (to prevent duplicated buttons)
                    return;

                if (!vm.currYear || !searchParams.CompanyId)
                    return;

                const params = Object.assign({}, searchParams);
                params.SearchType = 4;
                params.SearchText = vm.currYear;

                prevEvents[key] = { year: vm.currYear, loadingResult: true, events: [] };
                // set array to show loading events bar
                vm.loadingResult = true;

                ApiFactory.GetEventsByParameters(params)
                    .then(function (response) {
                        vm.loadingResult = false;
                        prevEvents[key].loadingResult = false;
                        prevEvents[key].events = response.data;
                        vm.prevEvents = prevEvents;
                        //set next year
                        vm.currYear = getPrevYear(vm.minYear);
                    }).catch(function (err) {
                        vm.currYear = getPrevYear(vm.minYear);
                        console.log(err);
                        vm.loadingResult = false;
                    })
            }


            vm.isRtl = function (txt) {
                return isRTL(txt);
            }

            function getEvents(onComplete) {
                if (vm.loadingResult) {
                    return;
                }
                if (vm.events.length >= vm.limit) {
                    return;
                }

                if (vm.SearchModel.CompanyId == 0)
                    return;

                vm.hasResult = false;
                vm.loadingResult = true;
                vm.SearchModel.SearchType = vm.currentType;
                ApiFactory.GetEventsByParameters(vm.SearchModel)
                    .then(function (response) {
                        //First function handles success
                        if (response.data && response.data.length > 0) {
                            vm.events = vm.events.concat(response.data);
                            vm.SearchModel.PageIndex++;
                            vm.loadingResult = false;
                            vm.hasResult = true;

                            if (response.data.length < vm.SearchModel.PageSize)
                                vm.limit = vm.events.length;

                            else
                                vm.limit += (vm.SearchModel.PageSize + 1);
                        }
                        else {
                            vm.loadingResult = false;
                            if (vm.events.length > 0) {
                                vm.limit = vm.events.length;
                                vm.hasResult = true;
                            }
                        }

                        if (onComplete)
                            onComplete();
                    }).catch(function (err) {
                        console.log(err);
                    })
            }

            const DEF_SIZE = 4.8;// 1200/250
            window.addEventListener("resize", function () {
                setImageHeight();
            });

            function setImageHeight() {
                const elements = document.querySelectorAll('.card-top');
                elements.forEach(function (el) {
                    el.style.height = (el.parentElement.offsetWidth / DEF_SIZE) + 'px';
                });
            }

            function getPrevYear(minYear) {
                if (currentYear <= minYear) //company doesn't have more prev events
                    return "";

                currentYear--;
                return currentYear.toString();
            }

        }]);
})();
